<template>
  <MarketingHeader>
    <PublicationTable />
  </MarketingHeader>
</template>

<script>
import MarketingHeader from "@/marketing/components/MarketingHeader.vue";
import PublicationTable from "@/marketing/components/tables/PublicationTable.vue";

// Écran « Publications » : diffuser et mesurer
export default {
  name: 'PublicationView',
  components: {MarketingHeader, PublicationTable},
}
</script>
